import { forwardRef } from 'react';
import downloadBG from "../assets/images/download_bg.png";
import appStore from "../assets/icons/app_store.png";
import googlePlay from "../assets/icons/google_play.png";
import { AppConstant } from '../constant/AppConstant';

const DownloadSection= forwardRef<HTMLElement, {}>((props, ref) => {
  return (
    <section className="all-main-section" ref={ref}>
      <div className="all-main-section-overlay"></div>
      <div className="all-main-section-content-wrapper">
        <div className="all-main-section-left">
          <img src={downloadBG} alt="App Preview" />
        </div>
        <div className="all-main-section-right">
          <h2 className="all-main-title">
            <span>Download</span> Our App
          </h2>
          <p className="all-main-paragraph">
            Manage your grocery and restaurant business effortlessly. Track orders, inventory,
            and analytics – all from your mobile device!
          </p>
          <div className="store-buttons">
            <a
              href={AppConstant.APP_STORE_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appStore} alt="App Store" />
            </a>
            <a
               href={AppConstant.PLAY_STORE_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googlePlay} alt="Google Play" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
});

export default DownloadSection;
